import { sprWithJobIdFlow } from "@/constants/common";
import { useRegistrationProps } from "@/context/useRegistrationProps";
import { useMobile } from "@/hooks";
import React from "react";

const ProgressBar = ({ percent = 0 }) => {
  const clampedPercent = Math.min(Math.max(percent, 0), 100);
  const isMobile = useMobile();
  const { flowType } = useRegistrationProps();
  return (
    <div className="flex w-full flex-col gap-3 md:!flex-col-reverse">
      <div
        className={`relative h-2 rounded-lg ${flowType === sprWithJobIdFlow ? (isMobile ? "bg-white" : "bg-brand-secondary") : "bg-white"}`}
      >
        <div
          style={{
            width: `${clampedPercent}%`,
            backgroundImage: `
              repeating-linear-gradient(
              135deg,rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.2) 5px, rgba(255, 255, 255, 0.05) 5px,rgba(255, 255, 255, 0.05) 10px
              ),
              linear-gradient(to right, #EB59BF, #36A1D4)
              `,
          }}
          className={`h-2 rounded-lg`}
        ></div>
        <div
          className={`border-border-subtle absolute top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-nowrap rounded-full border bg-white p-[6px] text-sm font-bold ${clampedPercent >= 97 ? "left-auto right-0 translate-x-0" : ""}`}
          style={{
            left: clampedPercent < 97 ? `${clampedPercent}%` : undefined,
          }}
        >
          {clampedPercent} %
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
